/**
 * Complete The Look — auto-matched looks + Shop the Look modal
 * complementary → related → fallback collection; diversify by category
 */
(function () {
  'use strict';

  var COLOR_HEX = {
    black: '#111111',
    'jet black': '#0a0a0a',
    white: '#f5f5f5',
    'off white': '#f3f0e8',
    ivory: '#fffff0',
    cream: '#fffdd0',
    beige: '#d8c3a5',
    tan: '#d2b48c',
    brown: '#6b4226',
    camel: '#c19a6b',
    navy: '#1b2a4a',
    blue: '#2f5f9e',
    'denim blue': '#3d5a80',
    indigo: '#3f51b5',
    grey: '#8a8a8a',
    gray: '#8a8a8a',
    charcoal: '#36454f',
    red: '#b33a3a',
    burgundy: '#6d1f2c',
    green: '#2f6b4f',
    olive: '#6b7c3c',
    pink: '#e8a0bf',
    purple: '#6b3fa0',
    yellow: '#e6c84a',
    orange: '#d4783a',
    gold: '#c5a46e',
    silver: '#c0c0c0',
  };

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function money(cents, format) {
    cents = Number(cents) || 0;
    var fmt = format || '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && fmt) {
      try {
        return Shopify.formatMoney(cents, fmt);
      } catch (e) {}
    }
    var amount = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{amount}}') !== -1) {
      return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    if (fmt && fmt.indexOf('{{amount_no_decimals}}') !== -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)));
    }
    return 'LE ' + amount;
  }

  function isColorOption(name) {
    return /color|colour|colorway|shade/i.test(String(name || ''));
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function absoluteUrl(url) {
    if (!url) return '';
    if (typeof url === 'object') url = url.src || url.url || '';
    url = String(url);
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function colorKey(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/\b(ii|iii|iv|2|3)\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function colorBackground(valueObj) {
    var swatch = valueObj && valueObj.swatch;
    if (swatch && swatch.image) return { backgroundImage: 'url(' + absoluteUrl(swatch.image) + ')' };
    if (swatch && swatch.color) return { backgroundColor: swatch.color };
    var key = colorKey(valueObj && valueObj.name);
    if (COLOR_HEX[key]) return { backgroundColor: COLOR_HEX[key] };
    var parts = key.split(/[\/&\-]/);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (COLOR_HEX[p]) return { backgroundColor: COLOR_HEX[p] };
    }
    return { backgroundColor: '#d0d0d0' };
  }

  function swatchBackground(product, optionPos, valueName, valObj) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v['option' + optionPos]) !== String(valueName)) continue;
      if (v.featured_image) {
        return { backgroundImage: 'url(' + absoluteUrl(v.featured_image) + ')' };
      }
    }
    return colorBackground(typeof valObj === 'object' ? valObj : { name: valueName });
  }

  function colorHasAnyAvailable(product, optionPos, valueName) {
    return (product.variants || []).some(function (v) {
      return String(v['option' + optionPos]) === String(valueName) && v.available;
    });
  }

  function productBlob(product) {
    return (
      String(product.product_type || '') +
      ' ' +
      String(product.type || '') +
      ' ' +
      String(product.title || '') +
      ' ' +
      String(product.tags || '') +
      ' ' +
      String(product.handle || '')
    ).toLowerCase();
  }

  function isGiftCard(product) {
    if (!product) return false;
    if (product.gift_card === true) return true;
    return /\bgift[\s-]?card\b/.test(productBlob(product));
  }

  function classifyProduct(product) {
    var blob = productBlob(product);

    if (/\b(fragrance|perfume|cologne|eau de|pour homme|pour femme)\b/.test(blob)) return 'fragrance';
    if (/\b(shoe|sneaker|loafer|footwear)\b/.test(blob) && !/\b(boot\s*cut|bootcut)\b/.test(blob)) return 'shoes';
    /* Blazers + dress suits are formal — never pair with jeans/shirts */
    if (/\b(blazer)\b/.test(blob)) return 'suits';
    if (/\b(suit)\b/.test(blob) && !/\b(track\s*suit|sweatsuit|suit\s*pant)\b/.test(blob)) return 'suits';
    /* Jackets before denim so "denim jacket" stays outerwear, not bottoms */
    if (/\b(jacket|coat|hoodie|vest|outerwear|bomber)\b/.test(blob)) return 'outerwear';
    if (/\b(jean|pant|trouser|denim|chino|short|legging)\b/.test(blob)) return 'bottoms';
    if (/\b(shirt|tee|t-shirt|polo|top|blouse|sweater|knit|tank)\b/.test(blob)) return 'tops';
    if (/\b(belt|hat|cap|bag|wallet|accessory|accessories|scarf)\b/.test(blob)) return 'accessories';
    return 'other';
  }

  function isCasualBottom(product) {
    var blob = (
      String(product.product_type || '') +
      ' ' +
      String(product.type || '') +
      ' ' +
      String(product.title || '') +
      ' ' +
      String(product.tags || '') +
      ' ' +
      String(product.handle || '')
    ).toLowerCase();
    if (/\b(jean|denim|chino|short|legging)\b/.test(blob)) return true;
    if (/\b(pant|trouser)\b/.test(blob) && !/\b(dress\s*pant|suit\s*pant|formal)\b/.test(blob)) return true;
    return false;
  }

  function genderOf(product) {
    var blob = (
      String(product.product_type || '') +
      ' ' +
      String(product.type || '') +
      ' ' +
      String(product.title || '') +
      ' ' +
      String(product.tags || '') +
      ' ' +
      String(product.handle || '')
    ).toLowerCase();
    if (/\b(kids?|boys?|girls?|youth|toddler|baby)\b/.test(blob)) return 'kids';
    if (/\b(women|woman|womens|ladies|female)\b/.test(blob)) return 'women';
    if (/\b(men|man|mens|male)\b/.test(blob)) return 'men';
    return 'unisex';
  }

  function genderCompatible(a, b) {
    if (!a || !b) return true;
    if (a === 'unisex' || b === 'unisex') return true;
    return a === b;
  }

  var PREFERRED_CATS = {
    tops: ['bottoms', 'outerwear', 'shoes', 'accessories'],
    bottoms: ['tops', 'outerwear', 'shoes', 'accessories'],
    outerwear: ['tops', 'bottoms', 'shoes', 'accessories'],
    suits: ['tops', 'shoes', 'accessories', 'bottoms'],
    shoes: ['bottoms', 'tops', 'accessories', 'outerwear'],
    accessories: ['tops', 'bottoms', 'shoes', 'outerwear'],
    fragrance: ['tops', 'bottoms', 'outerwear', 'shoes'],
    other: ['tops', 'bottoms', 'outerwear', 'shoes'],
  };

  var APPAREL_CATS = {
    tops: true,
    bottoms: true,
    outerwear: true,
    shoes: true,
    accessories: true,
  };

  function normalizeProduct(raw) {
    if (!raw) return null;
    var featured =
      raw.featured_image ||
      (raw.featured_media && (raw.featured_media.preview_image || raw.featured_media.src)) ||
      (raw.images && raw.images[0] && (raw.images[0].src || raw.images[0])) ||
      null;
    if (featured && typeof featured === 'object') {
      featured = featured.src || featured.url || null;
    }
    featured = absoluteUrl(featured);

    var options = raw.options || [];
    var normalizedOptions = options.map(function (opt, idx) {
      if (typeof opt === 'string') {
        return {
          name: opt,
          position: idx + 1,
          values: (raw.options_with_values && raw.options_with_values[idx]
            ? raw.options_with_values[idx].values
            : []
          ).map(function (v) {
            return typeof v === 'string' ? { name: v, swatch: null } : v;
          }),
        };
      }
      var values = (opt.values || []).map(function (v) {
        if (typeof v === 'string') return { name: v, swatch: null };
        return {
          name: v.name || v,
          swatch: v.swatch || null,
        };
      });
      /* Shopify /products/handle.js uses options: [{name, position, values: string[]}] */
      if (!values.length && Array.isArray(opt.values) === false && raw.variants) {
        var set = {};
        raw.variants.forEach(function (v) {
          var key = 'option' + (opt.position || idx + 1);
          if (v[key]) set[v[key]] = true;
        });
        values = Object.keys(set).map(function (name) {
          return { name: name, swatch: null };
        });
      }
      return {
        name: opt.name,
        position: opt.position || idx + 1,
        values: values,
      };
    });

    /* Build option values from variants when missing */
    normalizedOptions.forEach(function (opt) {
      if (opt.values && opt.values.length) return;
      var set = {};
      (raw.variants || []).forEach(function (v) {
        var val = v['option' + opt.position];
        if (val) set[val] = true;
      });
      opt.values = Object.keys(set).map(function (name) {
        return { name: name, swatch: null };
      });
    });

    var variants = (raw.variants || []).map(function (v) {
      var img =
        v.featured_image ||
        (v.featured_media && (v.featured_media.preview_image || v.featured_media.src)) ||
        null;
      if (img && typeof img === 'object') img = img.src || img.url || null;
      img = absoluteUrl(img);
      return {
        id: v.id,
        title: v.title,
        available: v.available !== false && (v.available == null ? true : !!v.available),
        price: v.price,
        compare_at_price: v.compare_at_price || 0,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        featured_image: img,
      };
    });

    var tags = raw.tags;
    if (Array.isArray(tags)) tags = tags.join(',');
    else tags = String(tags || '');

    return {
      id: raw.id,
      handle: raw.handle,
      title: raw.title,
      url: raw.url || (raw.handle ? '/products/' + raw.handle : '#'),
      available: raw.available !== false,
      featured_image: featured,
      price: raw.price,
      price_min: raw.price_min != null ? raw.price_min : raw.price,
      price_max: raw.price_max != null ? raw.price_max : raw.price,
      compare_at_price: raw.compare_at_price || 0,
      product_type: raw.product_type || raw.type || '',
      gift_card: raw.gift_card === true,
      tags: tags,
      options: normalizedOptions,
      variants: variants,
      category: null,
    };
  }

  function findVariant(product, selected) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var pos = 1; pos <= 3; pos++) {
        var key = 'option' + pos;
        if (selected[key] == null || selected[key] === '') continue;
        if (String(v[key]) !== String(selected[key])) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].available) return variants[j];
    }
    return variants[0] || null;
  }

  function optionAvailable(product, position, value, selected) {
    var probe = Object.assign({}, selected);
    probe['option' + position] = value;
    return (product.variants || []).some(function (v) {
      for (var pos = 1; pos <= 3; pos++) {
        var key = 'option' + pos;
        if (probe[key] == null || probe[key] === '') continue;
        if (String(v[key]) !== String(probe[key])) return false;
      }
      return v.available;
    });
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function hydrateProduct(item, force) {
    var normalized = normalizeProduct(item);
    if (!normalized || !normalized.handle) return Promise.resolve(normalized);
    if (
      !force &&
      normalized.variants &&
      normalized.variants.length &&
      normalized.options &&
      normalized.options.length
    ) {
      normalized.category = classifyProduct(normalized);
      return Promise.resolve(normalized);
    }
    return fetchJson('/products/' + encodeURIComponent(normalized.handle) + '.js')
      .then(function (full) {
        var p = normalizeProduct(full) || normalized;
        p.category = classifyProduct(p);
        /* Keep Liquid swatch metadata when product.js only has string option values */
        if (normalized.options && normalized.options.length) {
          p.options = mergeOptionSwatches(normalized.options, p.options);
        }
        return p;
      })
      .catch(function () {
        normalized.category = classifyProduct(normalized);
        return normalized;
      });
  }

  function mergeOptionSwatches(fromLiquid, fromJs) {
    if (!fromJs || !fromJs.length) return fromLiquid;
    return fromJs.map(function (opt, idx) {
      var liq = fromLiquid[idx];
      if (!liq || !liq.values) return opt;
      var map = {};
      liq.values.forEach(function (v) {
        if (v && v.name) map[String(v.name)] = v.swatch || null;
      });
      return {
        name: opt.name,
        position: opt.position || idx + 1,
        values: (opt.values || []).map(function (v) {
          var name = v.name || v;
          return {
            name: name,
            swatch: (v && v.swatch) || map[String(name)] || null,
          };
        }),
      };
    });
  }

  function loadCandidates(productId, limit, fallbackCollection) {
    var urls = [
      '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        limit +
        '&intent=complementary',
      '/recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        limit +
        '&intent=related',
    ];
    if (fallbackCollection) {
      urls.push(
        '/collections/' + encodeURIComponent(fallbackCollection) + '/products.json?limit=' + Math.max(limit, 40)
      );
    }

    return Promise.all(
      urls.map(function (url) {
        return fetchJson(url)
          .then(function (data) {
            return data.products || [];
          })
          .catch(function () {
            return [];
          });
      })
    ).then(function (groups) {
      var seen = {};
      var merged = [];
      groups.forEach(function (list) {
        (list || []).forEach(function (p) {
          if (!p || p.id == null) return;
          var id = String(p.id);
          if (seen[id]) return;
          seen[id] = true;
          merged.push(p);
        });
      });
      return merged;
    });
  }

  function takeFromList(list, usedIds, preferFresh, usedGlobal) {
    if (!list || !list.length) return null;
    var i;
    for (i = 0; i < list.length; i++) {
      var p = list[i];
      var id = String(p.id);
      if (usedIds[id]) continue;
      if (preferFresh && usedGlobal[id]) continue;
      return p;
    }
    if (preferFresh) {
      for (i = 0; i < list.length; i++) {
        var q = list[i];
        var qid = String(q.id);
        if (usedIds[qid]) continue;
        return q;
      }
    }
    return null;
  }

  /**
   * Build looks with category diversity (shirt + jean + shoes…), not 3 pants / 2 perfumes.
   * Only returns full looks. Rotates picks so multiple looks stay distinct.
   */
  function buildLooks(current, pool, looksCount, perLook, includeCurrent) {
    var currentCat = (current && current.category) || 'other';
    var currentGender = genderOf(current || {});
    var prefs = (PREFERRED_CATS[currentCat] || PREFERRED_CATS.other).slice();
    var minLookSize = Math.min(perLook, 3);

    var currentIsCasualBottom = current && (currentCat === 'bottoms' || isCasualBottom(current));
    var currentIsTop = currentCat === 'tops';

    var others = (pool || []).filter(function (p) {
      if (!p || !p.id) return false;
      if (current && String(p.id) === String(current.id)) return false;
      if (!genderCompatible(currentGender, genderOf(p))) return false;
      var cat = p.category || classifyProduct(p);
      p.category = cat;
      /* Jeans/shirts should never pair with dress suits/blazers or fragrance dumps */
      if ((currentIsCasualBottom || currentIsTop) && (cat === 'suits' || cat === 'fragrance')) return false;
      if (currentCat === 'suits' && isCasualBottom(p)) return false;
      if (APPAREL_CATS[currentCat] && cat === 'fragrance') return false;
      return true;
    });

    var buckets = {
      tops: [],
      bottoms: [],
      outerwear: [],
      suits: [],
      shoes: [],
      accessories: [],
      fragrance: [],
      other: [],
    };
    others.forEach(function (p, idx) {
      var cat = p.category || classifyProduct(p);
      p.category = cat;
      p._gender = genderOf(p);
      if (!buckets[cat]) buckets[cat] = [];
      /* Rotate starting point so later looks get different items */
      buckets[cat].push(p);
      p._order = idx;
    });
    Object.keys(buckets).forEach(function (key) {
      buckets[key].sort(function (a, b) {
        return (a._order || 0) - (b._order || 0);
      });
    });

    var usedGlobal = {};
    var looks = [];

    function pushPick(look, usedIds, usedCats, p) {
      if (!p) return false;
      var id = String(p.id);
      if (usedIds[id]) return false;
      look.push(p);
      usedIds[id] = true;
      usedCats[p.category || 'other'] = (usedCats[p.category || 'other'] || 0) + 1;
      usedGlobal[id] = true;
      return true;
    }

    function canAddCategory(usedCats, cat) {
      if (cat === 'fragrance' || cat === 'other') {
        return (usedCats.fragrance || 0) + (usedCats.other || 0) < 1;
      }
      /* Avoid stacking same apparel category (e.g. 3 pants) */
      return (usedCats[cat] || 0) < 1;
    }

    for (var lookIndex = 0; lookIndex < looksCount; lookIndex++) {
      var look = [];
      var usedCats = {};
      var usedIds = {};

      if (includeCurrent && current) {
        pushPick(look, usedIds, usedCats, current);
      }

      var rotated = prefs.slice(lookIndex % prefs.length).concat(prefs.slice(0, lookIndex % prefs.length));

      /* Pass 1: one product per preferred category, prefer unused globally */
      var pass;
      for (pass = 0; pass < 2 && look.length < perLook; pass++) {
        var preferFresh = pass === 0;
        for (var pi = 0; pi < rotated.length && look.length < perLook; pi++) {
          var want = rotated[pi];
          if (!canAddCategory(usedCats, want)) continue;
          var list = buckets[want] || [];
          /* Offset into bucket by look index for variety */
          var offsetList = list.slice(lookIndex).concat(list.slice(0, lookIndex));
          var pick = takeFromList(offsetList, usedIds, preferFresh, usedGlobal);
          if (pick) pushPick(look, usedIds, usedCats, pick);
        }
      }

      /* Pass 2: fill with apparel only, still unique categories first */
      var apparelOrder = ['tops', 'bottoms', 'outerwear', 'shoes', 'accessories'];
      for (pass = 0; pass < 2 && look.length < perLook; pass++) {
        for (var ai = 0; ai < apparelOrder.length && look.length < perLook; ai++) {
          var acat = apparelOrder[(ai + lookIndex) % apparelOrder.length];
          if (acat === currentCat && (usedCats[acat] || 0) >= 1) continue;
          if (!canAddCategory(usedCats, acat) && pass === 0) continue;
          if ((usedCats[acat] || 0) >= 1 && pass === 0) continue;
          if ((usedCats[acat] || 0) >= 2) continue;
          var apick = takeFromList(
            (buckets[acat] || []).slice(lookIndex).concat((buckets[acat] || []).slice(0, lookIndex)),
            usedIds,
            pass === 0,
            usedGlobal
          );
          if (apick) pushPick(look, usedIds, usedCats, apick);
        }
      }

      /* Pass 3: last resort — one fragrance/other only if still short */
      if (look.length < perLook && canAddCategory(usedCats, 'fragrance')) {
        var soft = takeFromList(buckets.accessories.concat(buckets.fragrance, buckets.other), usedIds, false, usedGlobal);
        if (soft && (soft.category === 'accessories' || soft.category === 'fragrance' || soft.category === 'other')) {
          pushPick(look, usedIds, usedCats, soft);
        }
      }

      if (look.length >= perLook) {
        looks.push(look.slice(0, perLook));
      } else if (look.length >= minLookSize) {
        looks.push(look);
      }
    }

    return looks;
  }

  function initRoot(root) {
    if (!root || root.dataset.ctlReady === 'true') return;
    root.dataset.ctlReady = 'true';

    var moneyFormat =
      (function () {
        try {
          var s = JSON.parse((qs(root, '[data-ctl-strings]') && qs(root, '[data-ctl-strings]').textContent) || '{}');
          return s.money_format || '';
        } catch (e) {
          return '';
        }
      })() ||
      root.getAttribute('data-money-format') ||
      '';
    var strings = {};
    var stringsEl = qs(root, '[data-ctl-strings]');
    try {
      strings = JSON.parse((stringsEl && stringsEl.textContent) || '{}');
    } catch (e) {
      strings = {};
    }
    if (strings.money_format) moneyFormat = strings.money_format;

    var modal = qs(root, '[data-ctl-modal]');
    var panel = qs(root, '[data-ctl-panel]');
    var backBtn = qs(root, '[data-ctl-back]');
    var closeBtns = qsa(root, '[data-ctl-close]');
    var listView = qs(root, '[data-ctl-view="list"]');
    var detailView = qs(root, '[data-ctl-view="detail"]');
    var titleEl = qs(root, '[data-ctl-title]');
    var looksEl = qs(root, '[data-ctl-looks]');
    var statusEl = qs(root, '[data-ctl-status]');
    var looksData = {};

    var state = {
      lookId: null,
      products: [],
      product: null,
      selected: { option1: null, option2: null, option3: null },
      view: 'list',
      /* productId -> { variantId, label, option1, option2, option3 } */
      addedByProductId: {},
    };

    function variantLabel(variant) {
      if (!variant) return '';
      var parts = [];
      [variant.option1, variant.option2, variant.option3].forEach(function (opt) {
        if (opt != null && String(opt).trim() !== '') parts.push(String(opt));
      });
      if (parts.length) return parts.join(' / ');
      return variant.title && variant.title !== 'Default Title' ? String(variant.title) : '';
    }

    function lookProductById(productId) {
      var id = String(productId);
      for (var i = 0; i < (state.products || []).length; i++) {
        var p = state.products[i];
        if (p && String(p.id) === id) return p;
      }
      return null;
    }

    function addedEntryFromCartItem(item) {
      if (!item) return null;
      var product = lookProductById(item.product_id);
      if (!product) return null;
      var variant = null;
      (product.variants || []).forEach(function (v) {
        if (String(v.id) === String(item.variant_id)) variant = v;
      });
      var label = variant
        ? variantLabel(variant)
        : item.variant_title && item.variant_title !== 'Default Title'
          ? String(item.variant_title)
          : '';
      return {
        variantId: item.variant_id,
        label: label,
        option1: variant ? variant.option1 : (item.options && item.options[0]) || null,
        option2: variant ? variant.option2 : (item.options && item.options[1]) || null,
        option3: variant ? variant.option3 : (item.options && item.options[2]) || null,
      };
    }

    /** Mark look products that are already in the Shopify cart. */
    function applyCartToAddedState(cart) {
      var next = {};
      ((cart && cart.items) || []).forEach(function (item) {
        var pid = String(item.product_id);
        if (next[pid]) return;
        var entry = addedEntryFromCartItem(item);
        if (entry) next[pid] = entry;
      });
      state.addedByProductId = next;
    }

    function syncAddedFromCart(shouldRender) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function (cart) {
          applyCartToAddedState(cart);
          if (shouldRender !== false && state.view === 'list' && modal && !modal.hidden) {
            renderList();
          }
          return cart;
        })
        .catch(function () {
          return null;
        });
    }

    function onExternalCartChange(event) {
      if (!modal || modal.hidden) return;
      var cart = event && event.detail && event.detail.cart;
      if (cart) {
        applyCartToAddedState(cart);
        if (state.view === 'list') renderList();
        return;
      }
      syncAddedFromCart(true);
    }

    document.addEventListener('cart:updated', onExternalCartChange);
    document.addEventListener('cart:refresh', onExternalCartChange);

    function setStatus(msg, hide) {
      if (!statusEl) return;
      if (hide) {
        statusEl.hidden = true;
        return;
      }
      statusEl.hidden = false;
      var text = qs(statusEl, '.ctl__status-text');
      if (text) text.textContent = msg || '';
    }

    function openLook(lookId) {
      var data = looksData[lookId] || { products: [] };
      state.lookId = lookId;
      state.products = data.products || [];
      state.view = 'list';
      state.product = null;
      state.addedByProductId = {};
      renderList();
      showView('list');
      openModal();
      /* Hydrate Added state from live cart (not only session adds) */
      syncAddedFromCart(true);
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      if (typeof modal.showModal === 'function' && !modal.open) {
        try {
          modal.showModal();
        } catch (e) {}
      }
      document.body.classList.add('ctl-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      if (typeof modal.close === 'function' && modal.open) modal.close();
      modal.hidden = true;
      document.body.classList.remove('ctl-modal-open');
      state.view = 'list';
      state.product = null;
      state.addedByProductId = {};
    }

    function showView(view) {
      state.view = view;
      if (listView) listView.hidden = view !== 'list';
      if (detailView) detailView.hidden = view !== 'detail';
      if (backBtn) backBtn.hidden = view !== 'detail';
      if (titleEl) titleEl.textContent = strings.shop_this_look || 'Shop This Look';
    }

    function renderList() {
      if (!listView) return;
      var html = '<ul class="ctl-list" role="list">';
      state.products.forEach(function (product, index) {
        if (!product) return;
        var price = money(product.price_min || product.price, moneyFormat);
        var compare =
          product.compare_at_price && product.compare_at_price > (product.price_min || product.price)
            ? money(product.compare_at_price, moneyFormat)
            : '';
        var img = absoluteUrl(product.featured_image || '');
        var added = state.addedByProductId[String(product.id)] || null;
        var statusHtml = '';
        if (added) {
          statusHtml =
            '<span class="ctl-list__status">' +
            '<span class="ctl-list__added">' +
            '<svg class="ctl-list__added-check" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            escapeHtml(strings.added || 'Added') +
            '</span>' +
            (added.label
              ? '<span class="ctl-list__variant">' + escapeHtml(added.label) + '</span>'
              : '') +
            '</span>';
        }
        html +=
          '<li class="ctl-list__item">' +
          '<button type="button" class="ctl-list__btn' +
          (added ? ' is-added' : '') +
          '" data-ctl-product-index="' +
          index +
          '"' +
          (added ? ' aria-description="' + escapeAttr((strings.added || 'Added') + (added.label ? ': ' + added.label : '')) + '"' : '') +
          '>' +
          (img
            ? '<img class="ctl-list__thumb" src="' +
              escapeAttr(img) +
              '" alt="" width="90" height="120" loading="lazy">'
            : '<span class="ctl-list__thumb" aria-hidden="true"></span>') +
          '<span class="ctl-list__meta">' +
          '<span class="ctl-list__name">' +
          escapeHtml(product.title) +
          '</span>' +
          '<span class="ctl-list__price">' +
          (compare ? '<span class="ctl-list__price-compare">' + escapeHtml(compare) + '</span>' : '') +
          '<span>' +
          escapeHtml(price) +
          '</span></span>' +
          statusHtml +
          '</span>' +
          '<svg class="ctl-list__chevron" viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>' +
          '</button></li>';
      });
      html += '</ul>';
      listView.innerHTML = html;
      qsa(listView, '[data-ctl-product-index]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-ctl-product-index'), 10);
          openProduct(state.products[idx]);
        });
      });
    }

    function applyVariantSelection(product, preferred) {
      var selected = {
        option1: preferred && preferred.option1 != null ? preferred.option1 : null,
        option2: preferred && preferred.option2 != null ? preferred.option2 : null,
        option3: preferred && preferred.option3 != null ? preferred.option3 : null,
      };
      var match = findVariant(product, selected);
      if (match && match.available) {
        state.selected = {
          option1: match.option1,
          option2: match.option2,
          option3: match.option3,
        };
        return match;
      }
      var first = null;
      for (var fi = 0; fi < (product.variants || []).length; fi++) {
        if (product.variants[fi].available) {
          first = product.variants[fi];
          break;
        }
      }
      if (!first) first = (product.variants || [])[0] || null;
      state.selected = {
        option1: first ? first.option1 : null,
        option2: first ? first.option2 : null,
        option3: first ? first.option3 : null,
      };
      return first;
    }

    function openProduct(product) {
      if (!product) return;
      showView('detail');
      if (detailView) {
        detailView.innerHTML = '<p class="ctl-detail__loading">' + escapeHtml(strings.loading || 'Loading…') + '</p>';
      }

      hydrateProduct(product, true).then(function (full) {
        var p = full || product;
        state.product = p;
        var previouslyAdded = state.addedByProductId[String(p.id)] || null;
        applyVariantSelection(p, previouslyAdded);
        renderDetail();
      });
    }

    function renderDetail() {
      if (!detailView || !state.product) return;
      var product = state.product;
      var variant = findVariant(product, state.selected) || (product.variants || [])[0];
      var img = absoluteUrl((variant && variant.featured_image) || product.featured_image || '');
      var price = money(variant ? variant.price : product.price, moneyFormat);
      var compare =
        variant && variant.compare_at_price && variant.compare_at_price > variant.price
          ? money(variant.compare_at_price, moneyFormat)
          : '';

      var optionsHtml = '';
      (product.options || []).forEach(function (option) {
        var pos = option.position;
        var selectedVal = state.selected['option' + pos];
        var colorOpt = isColorOption(option.name);
        var label =
          '<p class="ctl-detail__option-label">' +
          escapeHtml(option.name) +
          (selectedVal ? ': <span>' + escapeHtml(selectedVal) + '</span>' : '') +
          '</p>';

        if (colorOpt) {
          optionsHtml += '<div class="ctl-detail__option">' + label + '<div class="ctl-swatches">';
          (option.values || []).forEach(function (valObj) {
            var name = valObj.name || valObj;
            var anyAvail = colorHasAnyAvailable(product, pos, name);
            var bg = swatchBackground(product, pos, name, valObj);
            var style = '';
            if (bg.backgroundImage) style += 'background-image:' + bg.backgroundImage + ';background-size:cover;';
            if (bg.backgroundColor) style += 'background-color:' + bg.backgroundColor + ';';
            optionsHtml +=
              '<button type="button" class="ctl-swatch' +
              (String(selectedVal) === String(name) ? ' is-active' : '') +
              (anyAvail ? '' : ' is-unavailable') +
              '" style="' +
              style +
              '" data-option-position="' +
              pos +
              '" data-option-value="' +
              escapeAttr(name) +
              '" data-option-color="true" aria-label="' +
              escapeAttr(name) +
              '"' +
              (anyAvail ? '' : ' disabled') +
              '></button>';
          });
          optionsHtml += '</div></div>';
          return;
        }

        optionsHtml += '<div class="ctl-detail__option">' + label + '<div class="ctl-sizes">';
        (option.values || []).forEach(function (valObj) {
          var name = valObj.name || valObj;
          var avail = optionAvailable(product, pos, name, state.selected);
          optionsHtml +=
            '<button type="button" class="ctl-size' +
            (String(selectedVal) === String(name) ? ' is-active' : '') +
            (avail ? '' : ' is-unavailable') +
            '" data-option-position="' +
            pos +
            '" data-option-value="' +
            escapeAttr(name) +
            '"' +
            (avail ? '' : ' disabled') +
            '>' +
            escapeHtml(name) +
            '</button>';
        });
        optionsHtml += '</div></div>';
      });

      var canAdd = !!(variant && variant.available);
      detailView.innerHTML =
        '<div class="ctl-detail">' +
        '<div class="ctl-detail__media">' +
        (img
          ? '<img src="' + escapeAttr(img) + '" alt="' + escapeAttr(product.title) + '" width="600" height="800">'
          : '') +
        '</div>' +
        '<div class="ctl-detail__info">' +
        '<h4 class="ctl-detail__title">' +
        escapeHtml(product.title) +
        '</h4>' +
        '<div class="ctl-detail__price">' +
        (compare ? '<span class="ctl-detail__price-compare">' + escapeHtml(compare) + '</span>' : '') +
        '<span>' +
        escapeHtml(price) +
        '</span></div>' +
        optionsHtml +
        '<p class="ctl-detail__error" data-ctl-error hidden></p>' +
        '<div class="ctl-detail__actions">' +
        '<button type="button" class="ctl-detail__atc" data-ctl-atc' +
        (canAdd ? '' : ' disabled') +
        '>' +
        escapeHtml(canAdd ? strings.add_to_bag || 'Add to Bag' : strings.sold_out || 'Sold out') +
        '</button>' +
        '<a class="ctl-detail__link" href="' +
        escapeAttr(product.url) +
        '">' +
        escapeHtml(strings.view_details || 'View Details') +
        '</a></div></div></div>';

      qsa(detailView, '[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var pos = parseInt(btn.getAttribute('data-option-position'), 10);
          var value = btn.getAttribute('data-option-value');
          var isColor = btn.getAttribute('data-option-color') === 'true';

          if (isColor) {
            var key = 'option' + pos;
            var match = null;
            var variants = product.variants || [];
            for (var i = 0; i < variants.length; i++) {
              if (String(variants[i][key]) === String(value) && variants[i].available) {
                match = variants[i];
                break;
              }
            }
            if (!match) {
              for (var j = 0; j < variants.length; j++) {
                if (String(variants[j][key]) === String(value)) {
                  match = variants[j];
                  break;
                }
              }
            }
            if (match) {
              state.selected = {
                option1: match.option1,
                option2: match.option2,
                option3: match.option3,
              };
            } else {
              state.selected[key] = value;
            }
            renderDetail();
            return;
          }

          state.selected['option' + pos] = value;
          renderDetail();
        });
      });

      var atc = qs(detailView, '[data-ctl-atc]');
      if (atc) {
        atc.addEventListener('click', function () {
          addToCart(variant, atc);
        });
      }
    }

    function addToCart(variant, button) {
      var errorEl = qs(detailView, '[data-ctl-error]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (!variant || !variant.available) return;
      button.classList.add('is-loading');
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variant.id, quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof window.updatePopupCart === 'function') {
            try {
              window.updatePopupCart();
            } catch (e) {}
          }

          applyCartToAddedState(cart);

          button.classList.remove('is-loading');
          button.disabled = false;
          state.product = null;
          renderList();
          showView('list');
        })
        .catch(function (err) {
          button.classList.remove('is-loading');
          button.disabled = false;
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent =
              (err && (err.description || err.message)) ||
              strings.add_error ||
              'Could not add to bag. Try again.';
          }
        });
    }

    function renderLooks(looks) {
      if (!looksEl) return;
      looksData = {};
      var html = '';
      looks.forEach(function (products, index) {
        var lookId = 'auto-' + index;
        looksData[lookId] = { products: products };
        html += '<article class="ctl__look" role="listitem" data-ctl-look="' + lookId + '">';
        html += '<div class="ctl__look-grid" aria-hidden="true">';
        for (var i = 0; i < 4; i++) {
          var p = products[i];
          if (p && p.featured_image) {
            html +=
              '<div class="ctl__look-cell"><img src="' +
              escapeAttr(absoluteUrl(p.featured_image)) +
              '" alt="" loading="lazy" width="400" height="533"></div>';
          } else {
            html += '<div class="ctl__look-cell ctl__look-cell--empty"></div>';
          }
        }
        html += '</div>';
        html +=
          '<button type="button" class="ctl__shop-btn" data-ctl-shop>' +
          escapeHtml(strings.shop_the_look || 'Shop the Look') +
          '</button></article>';
      });
      looksEl.innerHTML = html;

      qsa(looksEl, '[data-ctl-look]').forEach(function (lookEl) {
        var btn = qs(lookEl, '[data-ctl-shop]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          openLook(lookEl.getAttribute('data-ctl-look'));
        });
      });
    }

    function bootAuto() {
      var productId = root.getAttribute('data-product-id');
      var looksCount = parseInt(root.getAttribute('data-looks-count'), 10) || 2;
      var perLook = parseInt(root.getAttribute('data-per-look'), 10) || 4;
      var recLimit = parseInt(root.getAttribute('data-rec-limit'), 10) || 16;
      var fallback = root.getAttribute('data-fallback-collection') || '';
      var includeCurrent = root.getAttribute('data-include-current') !== 'false';

      var currentEl = qs(root, '[data-ctl-current-product]');
      var current = null;
      try {
        current = normalizeProduct(JSON.parse((currentEl && currentEl.textContent) || 'null'));
      } catch (e) {
        current = null;
      }
      if (current) current.category = classifyProduct(current);
      if (current && isGiftCard(current)) {
        root.hidden = true;
        return;
      }

      var embedded = [];
      var candEl = qs(root, '[data-ctl-candidates]');
      try {
        embedded = JSON.parse((candEl && candEl.textContent) || '[]') || [];
      } catch (e2) {
        embedded = [];
      }

      setStatus(strings.loading || 'Finding looks…', false);

      function finalize(rawList) {
        var seen = {};
        var merged = [];
        (embedded || []).concat(rawList || []).forEach(function (raw) {
          var n = normalizeProduct(raw);
          if (!n || n.id == null) return;
          if (isGiftCard(n)) return;
          var id = String(n.id);
          if (seen[id]) return;
          seen[id] = true;
          n.category = classifyProduct(n);
          merged.push(n);
        });

        return Promise.all(merged.map(hydrateProduct)).then(function (pool) {
          pool = (pool || []).filter(function (p) {
            return p && !isGiftCard(p);
          });
          var looks = buildLooks(current, pool, looksCount, perLook, includeCurrent);
          if (!looks.length) {
            setStatus(strings.empty || 'No looks available for this product.', false);
            if (looksEl) looksEl.innerHTML = '';
            return;
          }
          setStatus('', true);
          renderLooks(looks);
        });
      }

      loadCandidates(productId, recLimit, fallback)
        .then(finalize)
        .catch(function () {
          return finalize([]);
        });
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        showView('list');
      });
    }
    if (modal) {
      modal.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeModal();
      });
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }
    if (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    if (root.hasAttribute('data-ctl-auto')) {
      bootAuto();
    }
  }

  function boot() {
    qsa(document, '[data-complete-the-look]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target || !event.target.querySelector) return;
    var root = event.target.querySelector('[data-complete-the-look]');
    if (root) {
      delete root.dataset.ctlReady;
      initRoot(root);
    }
  });
})();
